// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"6530a2d8","854":"6e5f98a9","991":"667d518a"}[chunkId] + ".chunk.css";
};